import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=af021592&scoped=true&"
import script from "./article-card.vue?vue&type=script&lang=js&"
export * from "./article-card.vue?vue&type=script&lang=js&"
import style0 from "./article-card.vue?vue&type=style&index=0&id=af021592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af021592",
  null
  
)

export default component.exports